export default __webpack_public_path__ + "static/media/Questions-pana.1e9ae7fa.png";